import { axiosPortalSearch } from "../axios";
import { SEARCH_ACTIONS } from "./actionTypes";
import { handleActionError } from "../util/error";

export const getVodSearchDataAction = ({
  searchText = "",
  filter = "newest",
  language,
  offset = 0,
  max = 12
}) => {
  const searchUrl = `/api/v1/search/${language}/media?keyword=${searchText}&range=[${offset}, ${parseInt(offset) + parseInt(max)}]&sort=["${filter}","desc"]`;

  return dispatch => {
    dispatch({
      type: SEARCH_ACTIONS.SEARCH_DATA._START,
      payload: { offset }
    });

    return axiosPortalSearch
      .get(searchUrl)
      .then(response => {
        const { data = {} } = response;
        dispatch({
          type: SEARCH_ACTIONS.SEARCH_DATA._SUCCESS,

          payload: { data: data, offset }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while searching for VODs", error);
        dispatch({
          type: SEARCH_ACTIONS.SEARCH_DATA._FAILURE
        });
      });
    };
};

export const resetSearchResults = id => {
  return dispatch => {
    dispatch({
      type: SEARCH_ACTIONS.SEARCH_DATA._RESET
    });
  };
};
